import { defineComponent as _defineComponent } from 'vue'
import RmpAlerts from "@rmp/core/components/alerts/RmpAlerts.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpAuthLayout',
  setup(__props) {

const route = useRoute();

const img = computed(() => {
	switch (route.name) {
		case RouteNames.SIGN_IN:
			return "/img/images/sign-in-image.jpg";
		default:
			return "/img/images/auth-image.jpg";
	}
});

return { __sfc: true,route, img, RmpAlerts }
}

})